import axios from './_defaults/v2/user';

export async function getPromotions({activitySlug, ...params}) {
    try {
        const response = await axios.get(`/promotions/${activitySlug}`, {
            params
        });

        return response?.data || [];
    } catch(error) {
        if(error.response?.status === 404) {
            return []
        }
        return error;
    }
}